import { Controller } from 'stimulus';
import Cookies from 'js-cookie';

export default class extends Controller {
  connect() {
    const cookiesBanner = Cookies.get('cookies_banner');
    if (!cookiesBanner) {
      this.element.classList.remove('hidden');
    }
  }

  hideBanner() {
    const hostname = window.location.hostname;
    const parts = hostname.split('.');
    const domainParts = parts.slice(-2);
    const mixlrDomain = domainParts.join('.');

    Cookies.set('cookies_banner', true, { expires: 365, domain: mixlrDomain });
    this.element.remove();
  }
}
